import { Component, OnInit } from "@angular/core";
import { ReportPageBase } from "../components/report-page-base";
import { ReportsService } from "../../shared/services/reports.service";
import { NotificationService } from "../../core/services/notification.service";
import { AppService } from "../../app.service";
import { NotificationType } from "../../core/services/notification-type";
import { saveAs } from 'file-saver';

@Component({
    selector: 'laboratory-samples-and-trials-report-page',
    templateUrl: './laboratory-samples-and-trials-report.page.html',
    styleUrls: [
        './laboratory-samples-and-trials-report.page.scss',
        '../../../vendor/libs/ngx-perfect-scrollbar/ngx-perfect-scrollbar.scss',
        '../../../vendor/libs/angular2-ladda/angular2-ladda.scss'
    ]
})
export class LaboratorySamplesAndTrialsReportPage extends ReportPageBase implements OnInit {
    constructor(
        private reportsService: ReportsService,
        private notificationService: NotificationService,
        private appService: AppService
    ) {
        super();
        appService.pageTitle = 'Отчет. Реестр проб и испытаний'
    }

        generateReport() {
            this.generateReportByDateRange((startDate, endDate) => {
                this.reportsService.getLaboratorySamplesAndTrials(startDate, endDate)
                    .subscribe(blob => {
                        if (blob.type === 'application/octet-stream') {
                            let nowDate = new Date();
                            saveAs(blob, `Реестр_проб_испытаний_${nowDate.toLocaleDateString()}_${nowDate.getHours()}_${nowDate.getMinutes()}_${nowDate.getSeconds()}.xlsx`);
                            this.dataGenerating = false;
                        } else if (blob.type === 'application/json') {
                            blob
                                .text()
                                .then(result => {
                                    const response = JSON.parse(result);
                                    if (!response.isSuccessful) {
                                        this.notificationService.error({
                                            title: 'Ошибка',
                                            message: response.errorDescription as string,
                                            notificationType: NotificationType.SweetAlert
                                        });
                                    }
    
                                    this.dataGenerating = false;
                                });
                        }
                    });
    
            });
        }
}